const scrollToPrevious = (carouselRefCurrent: HTMLDivElement, itemsOffset: Map<string, number>) => {
  const threshold = carouselRefCurrent.scrollLeft - carouselRefCurrent.offsetWidth;

  // If the scroll distance to the left is less than the carousel's width, scroll back to the beginning.
  if (threshold < 0) {
    carouselRefCurrent.scrollTo({
      left: 0,
      behavior: 'smooth',
    });

    return;
  }

  const iterator = itemsOffset?.entries();
  let currentEntry = iterator?.next();

  while (!currentEntry?.done) {
    const [, value] = currentEntry?.value;
    const nextEntry = iterator?.next();

    if (value < threshold && (nextEntry?.done || nextEntry?.value?.[1] >= threshold)) {
      const scrollLeft = nextEntry?.value?.[1] ?? value;
      carouselRefCurrent.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
      return;
    }
    currentEntry = nextEntry;
  }
};

export default scrollToPrevious;
